import { render } from "./PhysiciansResults.vue?vue&type=template&id=60775ee1"
import script from "./PhysiciansResults.vue?vue&type=script&lang=js"
export * from "./PhysiciansResults.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Website\\wwwroot\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__